import type { ReactNode } from 'react';

import styles from './EmptyState.module.css';

interface EmptyStateProps {
  children: ReactNode;
}

// Плейсхолдер для пустых списков/таблиц.
export function EmptyState({ children }: EmptyStateProps): JSX.Element {
  return <div className={styles.empty}>{children}</div>;
}
